import React from 'react';
import { render } from 'react-dom';
import App from './components/App';

import './assets/css/Reset.css';
import './assets/css/index.css';

render(<App />, document.getElementById('root'));
